import React from 'react';

import { Flex, FormField, FormHelp, Label, Paragraph } from '@zillow/constellation';
import { NumberStepper } from '@zillow/zrs-comet';

import type { Section } from '../../../models';
import { UNRELATED_PEOPLE } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_ALLOWED_PEOPLE = 4;

export default function UnrelatedPeople({ section, setSectionValues }: Props): JSX.Element {
  function onPeopleAllowedChange(value: number): void {
    setSectionValues({
      [UNRELATED_PEOPLE.FIELD_NAME.PEOPLE_ALLOWED]: value,
    });
  }

  const allowedPeople = section.getFieldValue(UNRELATED_PEOPLE.FIELD_NAME.PEOPLE_ALLOWED);

  return (
    <>
      <FormField
        label={<Label size="lg">How many unrelated people can occupy your property?</Label>}
        control={
          <Flex display="flex" alignItems="center" flexDirection="column">
            <NumberStepper min={0} max={4} value={Number(allowedPeople)} onChange={onPeopleAllowedChange} />
            <Paragraph>people are allowed</Paragraph>
          </Flex>
        }
        description={
          allowedPeople === MAX_ALLOWED_PEOPLE && (
            <Flex display="flex" alignItems="center" flexDirection="column">
              <FormHelp>{`${MAX_ALLOWED_PEOPLE} is the maximum`}</FormHelp>
            </Flex>
          )
        }
      />
    </>
  );
}

UnrelatedPeople.description = 'Specifically for the City of Boulder.';
